import type { WorkPostSheetItemTypesEnum } from '../types'

const TEXT_WPS_ITEMS = ['PREGNANCY_ADJUSTMENTS', 'BREASTFEEDING_ADJUSTMENTS']

export const isTextWPSItem = (type: WorkPostSheetItemTypesEnum): boolean => {
  return TEXT_WPS_ITEMS.includes(type)
}
